import api from "../config/api";

export const fetchAllDiscussions = async () => {
  const res = await api.get("/discussion/");
  return res.data.data;
};

export const fetchDiscussionById = async (id, flag) => {
  const res = await api.get(`/discussion/?id=${id}&flag=${flag}`);
  return res.data.data;
};

export const fetchDiscussionBySourceId = async (sourceId, flag) => {
  const res = await api.get(`/discussion/?sourceId=${sourceId}&flag=${flag}`);
  return res.data.data;
};

export const createDiscussion = async (formData) => {
  const res = await api.post(`/discussion/`, formData);
  return res.data;
};

export const updateDiscussion = async (id, formData) => {
  const res = await api.put(`/discussion/?id=${id}`, formData);
  return res.data;
};

export const deleteDiscussion = async (id) => {
  const res = await api.delete(`/discussion/?id=${id}`);
  return res.data;
};

export const deleteDiscussionBySource = async (sourceId, flag) => {
  const res = await api.delete(`/discussion/?sourceId=${sourceId}&flag=${flag}`);
  return res.data;
};
